var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.showLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("active_success.title")) + " ")]), _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("active_success.sub_title")) + " ")]), _vm.noticeMessage ? _c('Toast', {
    staticClass: "mt-3 mb-3",
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.noticeMessage) + " ")]) : _vm._e(), _c('b-card', {
    staticClass: "mt-3",
    attrs: {
      "img-src": _vm.getAvatar,
      "img-alt": "Image",
      "img-top": ""
    }
  }, _vm._l(_vm.showInfos, function (info) {
    return _c('div', {
      key: info.matched_key
    }, [info.display && _vm.getStaffInfo(info.matched_key) ? _c('span', [_c('div', [_vm._v(_vm._s(_vm.getStaffInfo(info.matched_key)))])]) : _vm._e()]);
  }), 0)], 1), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("active_success.button_text")) + " ")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }